var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDarkTheme = function SvgDarkTheme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19,
    viewBox: "0 0 17 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-abf9f32e-4f1f-414a-bb9d-854e218f41ee)",
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.964 6.77c0-2.432.927-4.646 2.446-6.31a9.365 9.365 0 1 0 4.875 15.451c-4.189-.934-7.32-4.672-7.32-9.141"
  }))));
};
export default SvgDarkTheme;